(function () {
    'use strict';

    function valueNotInListValidate() {
        return {
            restrict: 'A',
            scope: {
                valuesList: '='
            },
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                // add a parser that will process each time the value is 
                // parsed into the model when the user updates it.
                ngModel.$parsers.unshift(function (value) {
                    if (!scope.valuesList || scope.valuesList.length === 0) {
                        return value;
                    }

                    // test and set the validity after update.
                    var valid = scope.valuesList.indexOf(value) === -1;
                    // if it's valid, return the value to the model, 
                    // otherwise return undefined.

                    ngModel.$setValidity('valueNotInListValidate', valid);

                    return valid ? value : undefined;
                });

                // add a formatter that will process each time the value
                // is updated on the DOM element.
                ngModel.$formatters.unshift(function (value) {
                    // return the value or nothing will be written to the DOM.
                    return value;
                });
            }
        };
    }

    valueNotInListValidate.$inject = [];

    angular.module('ecap.common').directive('valueNotInListValidate', valueNotInListValidate);
})();